import { __assign } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import PanelProperties from '../../containers/handoff/PanelProperties';
import PanelBorder from '../../containers/handoff/PanelBorder';
import PanelCode from '../../containers/handoff/PanelCode';
import PanelContent from './PanelContent';
import PanelShadows from '../../containers/handoff/PanelShadows';
import PanelTextFill from '../../containers/handoff/PanelTextFill';
import PanelTypography from '../../containers/handoff/PanelTypography';
export default function HandoffText(_a) {
    var _b, _c, _d;
    var content = _a.content, copyBtnActive = _a.copyBtnActive, itemProps = _a.itemProps, onCopy = _a.onCopy, style = _a.style;
    return (React.createElement("div", null,
        React.createElement(PanelProperties, null),
        React.createElement(PanelTextFill, null),
        React.createElement(PanelTypography, __assign({ subFamily: (_d = (_c = (_b = itemProps === null || itemProps === void 0 ? void 0 : itemProps.data) === null || _b === void 0 ? void 0 : _b.MARVEL_SKETCH_PLUGIN) === null || _c === void 0 ? void 0 : _c.font) === null || _d === void 0 ? void 0 : _d.subFamily }, style)),
        React.createElement(PanelContent, { content: content, copyBtnActive: copyBtnActive, onCopy: onCopy }),
        React.createElement(PanelBorder, null),
        React.createElement(PanelShadows, null),
        React.createElement(PanelCode, null)));
}
HandoffText.propTypes = {
    content: PropTypes.string,
    onCopy: PropTypes.func,
    copyBtnActive: PropTypes.bool,
};
